<template>
  <form class="w-75 mx-auto">
    <div class="row align-items-center p-3 border-bottom">
      <div class="col-sm-4">
        <label for="family" class="form-label">Familia de materia prima asociada:</label>
      </div>
      <div class="col-sm-8">
        <select class="form-select" id="rawMat_id" v-model="rawMaterialId" @change="setMaterialByRawMatId(rawMaterialId)">
          <option selected value="0">Opciones disponibles...</option>
          <option v-for="rawMaterial in rawMaterialList" :key="rawMaterial._id" v-bind:value="rawMaterial.id">
            {{ rawMaterial.name }}
          </option>
        </select>
      </div>
    </div>
    <div class="row align-items-center p-3 border-bottom">
      <div class="col-sm-4">
        <label for="name" class="form-label">Nombre del perfil:</label>
      </div>
      <div class="col-sm-4">
        <select class="form-select" id="existName" @change="listNames" v-model="existName">
          <option selected value="0">Opciones disponibles...</option>
          <option v-for="name in profileName" :key="name">
            {{ name }}
          </option>
        </select>
      </div>
      <div class="col-sm-4">
        <input type="text" class="form-control" v-model="name" id="name" />
      </div>
    </div>
    <div class="row align-items-center p-3 border-bottom">
      <div class="col-sm-4">
        <label for="specification" class="form-label">Especificación/Norma:</label>
      </div>
      <div class="col-sm-4">
        <select class="form-select" id="existSpecification" @change="listSpecifications" v-model="existSpecification">
          <option selected value="0">Opciones disponibles...</option>
          <option v-for="specification in profileSpecification" :key="specification">
            {{ specification }}
          </option>
        </select>
      </div>
      <div class="col-sm-4">
        <input type="text" class="form-control" v-model="specification" id="specification" />
      </div>
    </div>
    <div class="row align-items-center p-3 border-bottom">
      <div class="col-sm-4">
        <label for="presentation" class="form-label">Presentación:</label>
      </div>
      <div class="col-sm-4">
        <select class="form-select" id="existPresentation" v-model="existPresentation" @change="listPresentations">
          <option selected value="0">Opciones disponibles...</option>
          <option v-for="presentation in profilePresentation" :key="presentation">
            {{ presentation }}
          </option>
        </select>
      </div>
      <div class="col-sm-4">
        <input type="text" class="form-control" id="presentation" v-model="presentation" />
      </div>
    </div>
    <div class="row align-items-center p-3 border-bottom">
      <div class="col-sm-4">
        <label for="heightlabel" class="form-label">Nombre de la variable 1 (Altura):</label>
      </div>
      <div class="col-sm-8">
        <select class="form-select" id="heightlabel" v-model="heightlabel">
          <option selected value="0">Opciones disponibles...</option>
          <option value="Altura del ala">Altura del ala</option>
          <option value="Altura total">Altura total</option>
          <option value="Altura total del perfil">
            Altura total del perfil
          </option>
        </select>
      </div>
    </div>
    <div class="row align-items-center p-3 border-bottom">
      <div class="col-sm-4">
        <label for="widthlabel" class="form-label">Nombre de la variable 2 (Ancho):</label>
      </div>
      <div class="col-sm-8">
        <select class="form-select" id="widthlabel" v-model="widthlabel">
          <option selected value="0">Opciones disponibles...</option>
          <option value="Ancho del ala">Ancho del ala</option>
          <option value="Ancho total">Ancho total del ala</option>
          <option value="Ancho total del perfil">
            Ancho total del perfil
          </option>
        </select>
      </div>
    </div>
    <div class="row align-items-center p-3 border-bottom">
      <div class="col-sm-4">
        <label for="thicknesslabel" class="form-label">Nombre de la variable 3 (Espesor del perfil):</label>
      </div>
      <div class="col-sm-8">
        <select class="form-select" id="thicknesslabel" v-model="thicknesslabel">
          <option selected value="0">Opciones disponibles...</option>
          <option value="Espesor de la base">Espesor de la base</option>
          <option value="Espesor del alma central">
            Espesor del alma central
          </option>
          <option value="no_aplica">
            No aplica
          </option>
        </select>
      </div>
    </div>
    <div class="row align-items-center p-3 border-bottom">
      <div class="col-sm-4">
        <label for="thicknesswinglabel" class="form-label">Nombre de la variable 4 (Espesor del ala):</label>
      </div>
      <div class="col-sm-8">
        <select class="form-select" id="thicknesswinglabel" v-model="thicknesswinglabel">
          <option selected value="0">Opciones disponibles...</option>
          <option value="Espesor del ala">Espesor del ala</option>
        </select>
      </div>
    </div>
    <div class="row align-items-center p-3">
      <div class="col-sm-4">
        <label for="price_id" class="form-label">Precio :</label>
      </div>
      <div class="col-sm-8">
        <select class="form-select" id="price_id" v-model="priceId">
          <option selected value="0">Opciones disponibles...</option>
          <option v-for="price in pricesList" :key="price._id" v-bind:value="price.id">
            {{ price.name }}
          </option>
        </select>
      </div>
    </div>
    <div class="p-3 border-bottom">
      <button class="btn btn-danger" @click.prevent="saveProfile" :disabled="isButtonDisabled">
        Cargar perfil
      </button>
    </div>
    <div class="row align-items-center p-3">
      <div class="col-sm-8 col-12">
        <div class="form-text">
          Para añadir los datos del perfil
          <i>(Espesores disponibles y el valor en pesos de cada servicio según
            el espesor.)</i>, descargue la siguiente plantilla de excel y haga las modificaciones
          necesarias sobre esta.
        </div>
      </div>
      <div class="col-sm-4 col-12">
        <button class="btn btn-secondary" @click.prevent="downloadTemplate">
          Descargar plantilla guía de la tabla
        </button>
      </div>
    </div>
    <div class="row align-items-center mt-3 mb-3">
      <div class="col-sm-8 col-12">
        <ul>
          <li>{{ condition1 }}</li>
          <li>{{ condition2 }}</li>
          <li>{{ condition3 }}</li>
          <li>{{ condition4 }}</li>
          <li>{{ condition5 }}</li>
          <li>{{ condition6 }}</li>
          <li>{{ condition7 }}</li>
          <li>{{ condition8 }}</li>
        </ul>
      </div>
      <div class="col-sm-4 col-12">
        <input type="file" ref="file" @change="previewFile()" />
        <hr />
      </div>
    </div>
    <div class="mx-auto">
      <button class="btn btn-danger" @click.prevent="saveProfileTypes">Guardar datos para el perfil</button>
    </div>
  </form>
</template>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_RUTA_BACKEND;
export default {
  data() {
    return {
      profileId: 0,
      priceId: 0,
      rawMaterialId: 0,
      priceDefault: "perf",
      pricesList: [],
      profileList: [],
      rawMaterialList: [],
      isButtonDisabled: false,
      //Campos
      material: "",
      existName: "",
      name: "",
      existPresentation: "",
      presentation: "",
      existSpecification: "",
      specification: "",
      heightlabel: "",
      widthlabel: "",
      thicknesslabel: "",
      thicknesswinglabel: "",
      fileProfileTypes: undefined,
      currentFile: undefined,
      //Listas sobre perfiles
      profileName: [],
      profileSpecification: [],
      profilePresentation: [],
      //Texto de la vista
      condition1: "El archivo debe contener los encabezados en la primera fila",
      condition2:
        "Puede agregar todas los registros que considere necesarios (filas).",
      condition3: "No debe alterar la cantidad de campos (columnas).",
      condition4: "El separador de decimales debe ser un punto(.).",
      condition5: "No debe tener separador de miles o millares.",
      condition6:
        "Asegurese de que los campos que tienen caracter como +, -, * o / son tratados como TEXTO en excel. De lo contrario pueden ser tomados como una operacion aritmética.",
      condition7:
        "No utilice ninguno de los siguientes caracteres $ % & | ° =  # ¿ ? ¡ ! '\"';",
      condition8:
        "Guarde el archivo en el mismo formato en que lo descargo (CSV delimitado por comas).",
    };
  },
  methods: {
    setMaterialByRawMatId(id) {
      // console.log(id);
      if (id === 5 || id === 6 || id === 7 || id === 8) {
        this.material = "ACERO AL CARBONO";
      } else {
        this.material = "";
      }
    },
    cleanData() {
      let commercialNames = new Set(this.profileList.map((item) => item.name));
      // console.log(commercialNames);
      commercialNames.forEach((element) => {
        this.profileName.push(element);
      });
      let specifications = new Set(
        this.profileList.map((item) => item.specification)
      );
      // console.log(specifications);
      specifications.forEach((element) => {
        this.profileSpecification.push(element);
      });
      let presentations = new Set(
        this.profileList.map((item) => item.presentation)
      );
      // console.log(presentations);
      presentations.forEach((element) => {
        this.profilePresentation.push(element);
      });
      // console.log(commercialNames);
      // console.log(specifications);
      // console.log(presentations);
    },
    listNames() {
      this.existName.trim() === "Opciones disponibles..."
        ? (this.name = "")
        : (this.name = this.existName);
    },
    listSpecifications() {
      this.existSpecification.trim() === "Opciones disponibles..."
        ? (this.specification = "")
        : (this.specification = this.existSpecification);
    },
    listPresentations() {
      this.existPresentation.trim() === "Opciones disponibles..."
        ? (this.presentation = "")
        : (this.presentation = this.existPresentation);
    },
    previewFile(event) {
      this.fileProfileTypes = this.$refs.file.files;
      // console.log(this.fileProfileTypes);
      this.currentFile = this.fileProfileTypes.item(0);
      // console.log(this.currentFile);
    },
    async saveProfile() {
      if (
        this.material == "" ||
        this.presentation == "" ||
        this.specification == "" ||
        this.heightlabel == "" ||
        this.widthlabel == "" ||
        this.thicknesswinglabel == "" ||
        this.thicknesslabel == "" ||
        this.priceId == 0 ||
        this.rawMaterialId == 0
      ) {
        alert(
          "Los campos están vacios, debe diligenciar aquellos que son obligatorios para cargar el perfil de forma exitosa."
        );
      } else {
        // console.log(this.profileList);
        let formData = new FormData();
        formData.append("name", this.name);
        formData.append("material", this.material);
        formData.append("presentation", this.presentation);
        formData.append("specification", this.specification);
        formData.append("heightlabel", this.heightlabel);
        formData.append("widthlabel", this.widthlabel);
        formData.append("thicknesslabel", this.thicknesslabel);
        formData.append("thicknesswinglabel", this.thicknesswinglabel);
        formData.append("price_id", this.priceId);
        formData.append("raw_material_family_id", this.rawMaterialId);
        // formData.forEach((element) => {
        //   console.log(element);
        // });
        try {
          let res = await axios.post(
            RUTA_SERVIDOR + "api/profile/create",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: "Bearer " + localStorage.getItem("token"),
              },
            }
          );
          // console.log(res.data);
          if (!res.data) {
            console.log("There has been a different error with the data.");
          } else {
            this.profileId = res.data[0].id;
            this.isButtonDisabled = true;
            alert("Perfil " + this.name + " " + this.specification + " cargado con exito!")
          }
        } catch (err) {
          console.log(`There has been an error ${err}`);
        }
      }
    },
    async saveProfileTypes() {
      if (this.profileId != 0) {
        // console.log(this.profileId);
        let formData = new FormData();
        formData.append("profile_id", this.profileId);
        formData.append("csvFile", this.currentFile);
        // formData.forEach(element => {
        //   console.log(element)
        // });
        try {
          let res = await axios.post(
            RUTA_SERVIDOR + "api/profile/type/create",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: "Bearer " + localStorage.getItem("token"),
              },
            }
          );
          // console.log(res.data);
          if (!res.data) {
            console.log("There has been a different error with the data.");
          } else {
            alert("Clasificación para: " + this.name + " agregada con exito!");
            this.cleanFields();
            this.$router.push("/Admin/ProfileCatalogue");
          }
        } catch (err) {
          console.log(`There has been an error ${err}`);
        }
      } else {
        alert(
          "No ha cargado ningún perfil guía todavía, complete la información previa antes de subir el archivo .csv."
        );
      }
    },
    cleanFields() {
      this.material = "";
      this.name = "";
      this.existName = "";
      this.existSpecification = "";
      this.specification = "";
      this.existPresentation = "";
      this.presentation = "";
      this.heightlabel = "";
      this.widthlabel = "";
      this.thicknesswinglabel = "";
      this.thicknesslabel = "";
      this.rawMaterialId = 0;
      this.priceId = 0;
      this.isButtonDisabled = false;
      this.profileId = 0;
    },
  },
  beforeMount() {
    //Listar precios asociados a la linea perfiles
    axios
      .get(RUTA_SERVIDOR + "api/price/list", {
        params: {
          price_type: this.priceDefault,
        },
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => (this.pricesList = res.data))
      .catch((err) => console.log(`There has been an error ${err}`));
    //Listar Perfiles previos
    axios
      .get(RUTA_SERVIDOR + "api/profile/list", {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => ((this.profileList = res.data), this.cleanData()))
      .catch((err) => console.log(`There has been an error ${err}`));
    //Listar materias primas asociadas a la linea Perfiles
    axios
      .get(RUTA_SERVIDOR + "api/rawMaterial/list", {
        params: {
          rawMaterial_type: this.priceDefault,
        },
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => (this.rawMaterialList = res.data))
      .catch((err) => console.log(`There has been an error ${err}`));
  }
};
</script>
<style scoped></style>